import React from 'react';
import DeviationLink from '../../../Duperbrowse/DeviationLink';
const ShopCardLink = ({ className, deviation, children })=>{
    return /*#__PURE__*/ React.createElement(DeviationLink, {
        className: className,
        deviation: deviation
    }, children);
};
ShopCardLink.displayName = 'ShopCardLink';
export default ShopCardLink;
